/*
 *   Copyright (c) 2024
 *   All rights reserved.
 */
import * as actionType from "../config/actionType";

const initialState = {
  indexTrajetSelected: -1,
  listTrajet: [],
  positionTotal: [],
};

export const trajetReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.TRAJET_LOADED:
      console.log("action [TRAJET_LOADED] ", action);
      return action.position;

    case actionType.TRAJET_LOADED_NEW: {
      console.log("action [TRAJET_LOADED_NEW] ", action);
      const newPositions = action?.trajet?.reduce((acc, trajet) => {
        return acc.concat(trajet.positions);
      }, []);

      return {
        ...state,
        indexTrajetSelected: initialState.indexTrajetSelected,
        listTrajet: action.trajet, // Les trajets
        positionTotal: newPositions, // Concatène les positions existantes avec les nouvelles
      };
    }

    case actionType.SET_TRAJET_SELECT:
      return {
        ...state,
        indexTrajetSelected: action.id,
      };
    default:
      return state;
  }
};
